// extracted by mini-css-extract-plugin
export default {"page":"StaffPage_page__ESM6I"};